import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import './CSS/App.css';

class Transition extends Component {
  state = {
    email: '',
    balance: 0,
    error: ''
  };

  // Fetch user details and balance from props.location.state (passed from Login7)
  componentDidMount() {
    const { email, balance } = this.props.location.state || {};
    if (email && balance !== undefined) {
      this.setState({ email, balance });
    } else {
      this.setState({ error: 'User data not found!' });
    }
  }

  // Update user balance
  updateBalance = async (newBalance) => {
    try {
      await fetch('/update-balance', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: this.state.email, newBalance }),
      });
      this.setState({ balance: newBalance });
    } catch (err) {
      console.error('Error updating balance', err);
      this.setState({ error: 'Failed to update balance' });
    }
  };

  handleExternalLink = async (url) => {
    const COST_PER_ACTION = 50;

    // Check if the user has enough balance
    if (this.state.balance < COST_PER_ACTION) {
      this.setState({ error: 'Not enough credits to proceed.' });
      return;
    }

    const confirmed = window.confirm(`Are you sure you want to proceed? This will deduct ${COST_PER_ACTION} credits.`);
    if (!confirmed) return;

    const newBalance = this.state.balance - COST_PER_ACTION;
    await this.updateBalance(newBalance);

    // Proceed to the external link (blockchain)
    window.location.href = url; // Navigate to the external URL
  };

  render() {
    const { email, balance, error } = this.state;

    return (
      <div className='App'>
        <img className='logo' src={logo} alt="Logo" />
        <br />
        <div>
          Please Confirm to go to External Blockchain. This will cost you 50 Credits...
        </div>
        <br />
        <div>
          <p>Email: {email}</p>
          <p>Balance: {balance} credits</p>
        </div>
        {error && <div style={{ color: 'red' }}>{error}</div>}
        <div>
          <button
            onClick={() => this.handleExternalLink('http://68.183.229.51:3000/conduct-transaction')}
            style={{
              backgroundColor: 'red', // Red background for the button
              color: 'white', // White text
              padding: '15px 32px', // Padding for the button
              textAlign: 'center', // Center text
              textDecoration: 'none', // Remove underline
              borderRadius: '5px', // Rounded corners
              fontSize: '16px', // Font size
              display: 'inline-block', // Allow the button to behave like a block-level element
              cursor: 'pointer', // Cursor pointer to indicate clickability
              animation: 'flicker 1s infinite', // Apply flicker animation
            }}
          >
            Proceed to Blockchain
          </button>
        </div>
        <br />
        <div>Powered by</div>
        <img className='logo2' src={logo2} alt="Logo 2" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default withRouter(Transition);
